import {
  CLEAN_IPB_DIRECTORY_LISTING,
  CLEAN_IPB_DIRECTORY_LISTING_ERROR,
} from '_models/redux/types';

export const cleanIpbDirectoryListingAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_IPB_DIRECTORY_LISTING,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_IPB_DIRECTORY_LISTING_ERROR,
    });
  }
};
